import {Chip, MenuItem, Select, Tooltip} from '@mui/material';
import React, { useEffect, useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { DefaultSelectProps } from "../../services/common/Constants";
import i18next from "i18next";
import useStyles from "../../style/js-style/components/attributes/AttributeMultipleSelectionInputStyle";

const AttributeMultipleSelectChips = ({ selected, formMethods, inputRef = null }) => {
  const { classes } = useStyles();
  if (!selected || selected.length === 0) {
    return <em>{i18next.t("notSpecified")}</em>;
  }

  return (
    <div className={classes.chipsContainer} ref={inputRef}>
      {selected.map((value,index) => (
        <Tooltip title={value}>
          <Chip
            className={classes.chip}
            key={value}
            label={value}
            variant="outlined"
            size="small"
            deleteIcon={
              <img
                src={process.env.PUBLIC_URL + "/img/icons/cross.svg"}
                alt="close"
                onMouseDown={(event) => event.stopPropagation()}
                className={classes.deleteItemIcon}
              />
            }
            onDelete={(event) => {
              event.preventDefault();
              formMethods.setValue(
                "values",
                selected?.filter((x) => x !== value)
              );
            }}
          />
        </Tooltip>
      ))}
    </div>
  );
};

const AttributeMultipleSelectInput = ({ listItems, setSelectedAttribute = () => {}, save = () => {} }) => {
  const formMethods = useFormContext();

  const inputRef = useRef(null);
  const wrapperRef = useRef(null);

  // Permet la suppression des items via la croix sans fermer l'input
  useEffect(() => {
    function handleClickOutside(event) {
      if (event.target.closest(".MuiList-root") || event.target.closest(".MuiPaper-root")) return;

      const isClickIsOutsideMainWrapperAndNoValues = !formMethods.getValues("values").length && wrapperRef.current && !wrapperRef.current.contains(event.target);
      const isClickIsOutsideMainWrapperAndChipAndValues = inputRef.current && !inputRef.current.contains(event.target) && wrapperRef.current && !wrapperRef.current.contains(event.target);

      if (isClickIsOutsideMainWrapperAndNoValues || isClickIsOutsideMainWrapperAndChipAndValues) {
        save();
        setSelectedAttribute(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, [inputRef, wrapperRef]);

  return (
    <Controller
      control={formMethods.control}
      name="values"
      render={({ field }) => (
        <Select
          {...field}
          id="tp-attribute-multiselect-id"
          multiple
          displayEmpty
          autoFocus
          ref={wrapperRef}
          onChange={(event) =>
            formMethods.setValue("values", event.target.value)
          }
          variant="outlined"
          MenuProps={DefaultSelectProps.MenuProps}
          renderValue={(selected) => (
            <AttributeMultipleSelectChips
              key={selected}
              selected={selected}
              formMethods={formMethods}
              inputRef={inputRef}
            />
          )}
          sx={{
            border: "none",
            borderRadius: "0 12px 12px 0",
            fontSize: "14px",
            paddingRight: "16px",
            height: "100%",
          }}
        >
          {listItems?.map((item) => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        </Select>
      )}
    />
  );
};
export default AttributeMultipleSelectInput;
